import BaseDto from '../BaseDto';

export default class ContribuableIsDto extends BaseDto {
  /**
   * Structure de la classe
   * @return {{dateNaissance: undefined, id: undefined, version: undefined, nom: undefined, prenom: undefined}}
   */
  get schema() { // eslint-disable-line
    return Object.assign(super.schema,
      {
        // noAvs: undefined,
        // noMatricule: undefined,
        // nom: undefined,
        // prenom: undefined,
        frontalier: undefined, // type résident
        // adresseRue: undefined,
        // adresseLocalite: undefined,
        tauxActivite: undefined,
        etatCivil: undefined,
        enfantaCharge: undefined, // hasEnfants
        // isMarie: undefined,
        conjointRevenu: undefined, // hasConjointRevenu
        conjointFonctionnaireInternationale: undefined,
        typeFonctionnaireInternational: undefined,
        // remarques: undefined,
        // sourceRevenu: [],
        isEnUnionLibre: undefined,
        isRevenuUnSeulEmployeur: undefined,
        gardeAlternee: undefined,
        dateNaissanceEnfants: undefined,
        nbEnfantBaremeH: undefined,
        communications: [],
        canton: undefined,
        dateChangementEtatCivil: undefined,
        tauxGlobalActivite: undefined,
        // isBaremeAjuste: undefined,
        // bareme: undefined,
        // isMessageBaremeH: undefined,
      });
  }

  /**
   * Fonction appelée en callback pour créer une nouvelle instance
   * @param inoJson Flux json
   * @return {DossierDto}
   */
  static getFactory(inoJson = {}) {
    return new ContribuableIsDto(inoJson);
  }
}
